import { ISignin } from 'src/interfaces';
import http from './http';

class SigninService {
  static signin(data: ISignin) {
    return http.post('/auth/signin', data);
  }
}
export default SigninService;
